import { logErrors } from '../config/config.json';


export function logError(message?: any, ...params: any[]) {
    if (logErrors) {
        console.log(message, ...params)
    }
}